import { navigateTo } from '../http/redirect';
import MapSearch from '../maps/search-map';
import LocationFeature from '../maps/models/feature';
import { captureException } from '../logging/logger';

class MapSearchService {
    mapElement: HTMLElement;
    mapSearch!: MapSearch;
    _options: MapSearchConfig;

    constructor( mapElement: HTMLElement ) {
        this.mapElement = mapElement;

        this._options = Object.assign( {
            propertyAPI: new URL( window.location.origin ),
            debug: process.env.MAP_SEARCH_DEBUG === 'true',
            fitBoundsOnClick: true,
            initialLocation: new LocationFeature(),
            stringTemplates: {},
            geoAPI: {
                url: window.geoAPI,
            },
        }, window.mapSearchConfig );

        if ( this._options.location && this._options.location.id > 0 ) {
            this._options.initialLocation = LocationFeature.fromJSON( JSON.stringify( this._options.location ) );
        }
    }

    async init(): Promise<void> {
        try {
            this.mapSearch = new MapSearch( this.mapElement, this._options );
        } catch ( error ) {
            const currentURL = new URL( window.location.href );
            currentURL.searchParams.delete( 'mode' );

            if ( window.environment !== 'production' ) {
                throw error;
            }

            captureException( error );

            navigateTo( currentURL.toString() );
        }
    }
}

const mapContainer = document.querySelector<HTMLElement>( '#twc__map-search-map' );

if ( !window.mapSearchService && mapContainer ) {
    window.mapSearchService = new MapSearchService( mapContainer );
}
